import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'mobx-react';
import {BrowserRouter as Router} from 'react-router-dom';
import store from './store';
import notificationsStore from './store/NotificationsStore';
import localizationStore from './store/LocalizationStore';
import App from './containers/App'
import './style.css';


ReactDOM.render(
    <Provider store={store} notificationsStore={notificationsStore} localizationStore={localizationStore}>
        <Router>
            <App />
        </Router>
    </Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js